export const TEMPLATE_FREEDOMPAY = 'freedompay';
export const TEMPLATE_LLOYDS = 'lloyds';

export const TEMPLATE_DEFAULT = 'default';
